<div class="container" fxLayout="column" fxLayoutGap="10px">
  <div class="maturity-level">
    {{ res("Ubt-MeasureDetail-Maturity-Level") }} [{{ maturityLevel() }}]
  </div>
  @if (!isViewerMode()) {
    <abc-button
      id="action"
      [ngClass]="'submit-button'"
      stylingMode="text"
      [text]="
        (['Modify', 'Withdraw'].includes(action)
          ? ''
          : nextMaturityLevel() + ' - ') +
        res(`Ubt-MeasureDetail-Approval-Request-${action}`)
      "
      type="default"
      (onClick)="openRequestPopUp()"
      [icon]="actionIcon"
    >
    </abc-button>
  }
  @if (isActiveRequest()) {
    <div fxLayout="row">
      <span class="attr"
        >{{ res("Ubt-MeasureDetail-Approval-Request-Status") }}:</span
      >
      <span class="value">{{
        res(`Ubt-MeasureDetail-Approval-Request-${format()}`)
      }}</span>
    </div>
    <div fxLayout="row">
      <span class="attr" fxFlex="none"
        >{{ res("Ubt-MeasureDetail-Approval-Request-Time") }}:</span
      >
      <span class="value">{{ lastStep.Date | date: "dd.MM.yyyy, HH:mm" }}</span>
    </div>
  }
  @if (measureProgress()) {
  <abc-button
    class="timeline-button"
    stylingMode="text"
    [text]="res('Ubt-MeasureDetail-Approval-Request-Open-Timeline')"
    type="default"
    [icon]="timeIcon"
    [activeStateEnabled]="false"
    (onClick)="openRequestPopUp(true)"
  >
  </abc-button>
} @else {
  <div class="tooltip-content">
  <i class="dx-icon-info"></i>
  <span>
    {{ dataService.res('Ubt-MeasureDetail-Approval-Request-Empty-StatusReport') }}
  </span>
  </div>
}
</div>

<!--- Request | Timeline Popup -->

<abc-popup
  #requestPopUp
  [height]="'700px'"
  [maxHeight]="'100%'"
  [minHeight]="'400px'"
  [width]="'90%'"
  [maxWidth]="'700px'"
  [minWidth]="'250px'"
  [showTitle]="true"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  (onHiding)="onRequestPopupHiding()"
>
  <div *dxTemplate="let data of 'title'">
    <div class="custom-popup-header">
      <div class="custom-popup-title">
        <div
          *appCheckPermission="{
            context: PermissionContext.MeasureChangeHartegrad,
            action: ActionType.See,
          }"
          class="main-title"
        >
          {{ res("Ubt-MeasureDetail-Approval-Request-Change-Maturity-Level") }}
        </div>
        <div
          *appCheckPermission="[
            permissions.createApprovalRequest,
            permissions.approveRequestStep1,
            permissions.approveRequestStep2,
          ]"
        >
          <div class="subtitle">
            {{
              res("Ubt-MeasureDetail-Approval-Request-Change-Maturity-Level") +
                " " +
                maturityLevel() +
                " -> " +
                nextMaturityLevel()
            }}
          </div>
          <div class="main-title">
            {{ res("Ubt-MeasureDetail-Approval-Request-Approval-Process") }}
          </div>
        </div>
      </div>
      <div class="close-icon-right" (click)="closeRequestPopup()">
        <i class="dx-icon dx-icon-close"></i>
      </div>
    </div>
  </div>
  <div
    class="dx-card popup-card-paddings card-radius"
    style="overflow-y: scroll"
  >
    <ubt-geods-request-popup
      #requestPopUpContent
      [isTimeline]="isTimeline()"
      (timelineRequested)="isTimeline.set($event)"
      [maturityLevel]="maturityLevel()"
      (maturityLevelChanged)="updateMaturityLevel($event)"
      (newStepAdded)="verifyNewStep()"
    ></ubt-geods-request-popup>
  </div>
</abc-popup>

